import DataTableInit from './datatable.js';

$(document).ready(function() {
    if($('.settings-user-data-table').length) {

        var dataTable = $('.settings-user-data-table').DataTable({
            processing: true,
            serverSide: true,
            language : {
                sLengthMenu: "Show _MENU_"
            },
            ajax: window.site.settingsTableData,
            columns: [
                { data: 'id', name: 'users.id' },
                { data: 'name', name: 'users.first_name' },
                { data: 'email', name: 'users.email'},
                { data: 'role_name', name: 'roles.role_name' },
            ],
            "fnDrawCallback":function(){
                DataTableInit.handlePaginationState();
                DataTableInit.addDropdownArrows();
                DataTableInit.makeRowsClickable();
                DataTableInit.addDropdownArrowsSelectbox();
            },
            "fnInitComplete":function() {
                DataTableInit.addSearchCross();
                DataTableInit.makeRowsClickable();
            },
            'createdRow': function( row, data, dataIndex ) {
                $(row).attr('data-href', window.site.url + '/user/' + data.id + '/edit');
                $(row).attr('data-visit-id', data.id);
            },
        });

        DataTableInit.construct(dataTable);

        dataTable.order( [[ 0, 'desc' ], [ 1, 'desc']] ).draw();

    }
});


// WEBPACK FOOTER //
// ./settings-datatable.js